module.exports = __webpack_public_path__ + "img/Voilages.8ce2fa1.jpg";